import { getProperty } from 'customer-data-objects/objects/ObjectAccessors';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { useCallback } from 'react';
import getIn from 'transmute/getIn';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const TwoLines = styled.span.withConfig({
  displayName: "TitleProperty__TwoLines",
  componentId: "sc-1ydwut3-0"
})(["display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;"]);

// Line-based truncation is unsupported, so 52 characters is approximately two lines in the cards
export const MAX_CARD_TITLE_LENGTH = 52;
const alwaysUndefined = () => undefined;
export const TitleProperty = ({
  subject,
  objectTypeDefinition,
  titleProperty
}) => {
  const getAdditionalPropertyValue = useCallback(propertyName => getIn(['properties', propertyName, 'value'], subject), [subject]);
  let title = '--';

  //get title value
  const titleValue = getProperty(subject, objectTypeDefinition.primaryDisplayLabelPropertyName);

  //if we dont have a title property use value as string || '--'
  if (!titleProperty) {
    title = titleValue || '--';
  } else {
    //If we do have title property lets use FormattedPropertyV2
    title = /*#__PURE__*/_jsx(FormattedPropertyV2, {
      objectTypeId: objectTypeDefinition.objectTypeId,
      objectId: `${subject.objectId}`,
      property: titleProperty,
      value: titleValue,
      getDraftValue: getAdditionalPropertyValue,
      getSavedValue: alwaysUndefined,
      getAdditionalPropertyValue: getAdditionalPropertyValue,
      dateFormat: "L",
      dateTimeFormat: "L"
    });
  }

  // render out a tooltip around the TwoLines Wrapper
  // Two lines uses css to restrict to a max of two
  // lines that are truncated with ...
  return /*#__PURE__*/_jsx(Tooltip, {
    title: title,
    children: /*#__PURE__*/_jsx(TwoLines, {
      children: title
    })
  });
};